export type Stroke =
  | "triangle"
  | "x"
  | "rectangle"
  | "circle"
  | "check"
  | "zig-zag"
  | "arrow"
  | "left square bracket"
  | "right square bracket"
  | "v"
  | "hourglass"
  | "trigram"
  | "cross"
  | "pentagram"
  | "heptagram"
  | "octagram"
  | "pigtail"
  | "spiral"
  | "diamond"
  | "heart"
  | "pentagon"
  | "kite"
  | "crescent"
  | "triquetra"
  | "infinity"
  | "chalise"
  | "ankh"
  | "hexagram"
  | "droplet"
  | "pique"
  | "trefle"
  | "keyhole"
  | "carolingian-cross";

const strokes: Record<Stroke, Array<[number, number]>> = {
  triangle: [
    [100, 40],
    [60, 160],
    [140, 160],
    [100, 40]
  ],
  x: [
    [60, 60],
    [140, 140],
    [100, 100],
    [140, 60],
    [60, 140],
    [100, 100]
  ],
  rectangle: [
    [50, 75],
    [150, 75],
    [150, 125],
    [50, 125],
    [50, 75]
  ],
  circle: [
    [150, 100],
    [147, 119],
    [139, 137],
    [125, 150],
    [106, 157],
    [85, 157],
    [66, 150],
    [50, 137],
    [42, 119],
    [39, 100],
    [42, 81],
    [50, 63],
    [66, 50],
    [85, 43],
    [106, 43],
    [125, 50],
    [139, 63],
    [147, 81],
    [150, 100]
  ],
  check: [
    [60, 110],
    [90, 140],
    [140, 70]
  ],
  "zig-zag": [
    [50, 125],
    [75, 75],
    [100, 125],
    [125, 75],
    [150, 125]
  ],
  arrow: [
    [100, 150],
    [100, 70],
    [80, 90],
    [120, 90],
    [100, 70]
  ],
  "left square bracket": [
    [120, 50],
    [80, 50],
    [80, 150],
    [120, 150]
  ],
  "right square bracket": [
    [80, 50],
    [120, 50],
    [120, 150],
    [80, 150]
  ],
  v: [
    [70, 60],
    [100, 140],
    [130, 60]
  ],
  hourglass: [
    [70, 50],
    [130, 50],
    [70, 150],
    [130, 150],
    [70, 50]
  ],
  trigram: [
    [100, 30],
    [110, 114],
    [178, 165],
    [100, 132],
    [22, 165],
    [90, 114],
    [100, 30]
  ],
  cross: [
    [100, 10],
    [110, 90],
    [190, 100],
    [110, 110],
    [100, 190],
    [90, 110],
    [10, 100],
    [90, 90],
    [100, 10]
  ],
  pentagram: [
    [100, 180],
    [53, 35],
    [176, 125],
    [24, 125],
    [147, 35],
    [100, 180]
  ],
  heptagram: [
    [100, 24],
    [133, 168],
    [41, 53],
    [174, 117],
    [26, 117],
    [159, 53],
    [67, 168],
    [100, 24]
  ],
  octagram: [
    [100, 24],
    [154, 154],
    [24, 100],
    [154, 46],
    [100, 176],
    [46, 46],
    [176, 100],
    [46, 154],
    [100, 24]
  ],
  pigtail: [
    [80, 100],
    [82, 96],
    [84, 93],
    [86, 90],
    [88, 87],
    [90, 85],
    [92, 83],
    [94, 82],
    [96, 81],
    [98, 80],
    [100, 80],
    [102, 80],
    [104, 81],
    [106, 82],
    [108, 83],
    [110, 85],
    [112, 87],
    [114, 90],
    [116, 93],
    [118, 96],
    [120, 100]
  ],
  spiral: [
    [110, 90],
    [112, 91],
    [113, 93],
    [115, 95],
    [116, 97],
    [116, 100],
    [116, 103],
    [115, 106],
    [113, 109],
    [111, 111],
    [108, 113],
    [105, 115],
    [101, 116],
    [97, 116],
    [93, 115],
    [90, 114],
    [86, 112],
    [83, 109],
    [81, 106],
    [79, 102],
    [78, 98],
    [78, 94],
    [79, 90],
    [80, 86],
    [83, 82],
    [86, 79],
    [90, 76],
    [94, 74],
    [99, 73],
    [104, 73],
    [109, 74],
    [114, 76],
    [118, 79],
    [123, 83],
    [126, 88],
    [129, 93],
    [131, 99],
    [132, 105],
    [131, 111],
    [129, 117],
    [126, 122],
    [122, 127],
    [117, 131],
    [111, 134],
    [104, 136],
    [97, 136],
    [90, 135],
    [83, 133],
    [77, 129],
    [72, 124]
  ],
  diamond: [
    [100, 40],
    [130, 100],
    [100, 160],
    [70, 100],
    [100, 40]
  ],
  heart: [
    [100, 83],
    [100, 82],
    [100, 82],
    [100, 81],
    [101, 80],
    [101, 78],
    [102, 77],
    [103, 75],
    [105, 73],
    [107, 71],
    [109, 69],
    [111, 67],
    [114, 65],
    [118, 63],
    [121, 61],
    [125, 60],
    [130, 59],
    [134, 59],
    [138, 58],
    [143, 58],
    [148, 59],
    [152, 60],
    [157, 61],
    [161, 63],
    [165, 65],
    [168, 67],
    [172, 69],
    [174, 72],
    [177, 75],
    [178, 78],
    [179, 81],
    [180, 85],
    [180, 88],
    [179, 91],
    [178, 95],
    [176, 98],
    [174, 101],
    [171, 104],
    [168, 108],
    [164, 111],
    [160, 114],
    [156, 117],
    [151, 120],
    [147, 122],
    [142, 125],
    [138, 128],
    [133, 131],
    [129, 133],
    [125, 136],
    [121, 138],
    [117, 141],
    [114, 143],
    [111, 146],
    [108, 148],
    [106, 150],
    [104, 152],
    [103, 154],
    [102, 155],
    [101, 156],
    [101, 158],
    [100, 158],
    [100, 159],
    [100, 159],
    [100, 159],
    [100, 159],
    [100, 159],
    [100, 158],
    [99, 157],
    [99, 156],
    [98, 155],
    [97, 153],
    [95, 151],
    [93, 149],
    [91, 147],
    [88, 145],
    [85, 143],
    [82, 140],
    [78, 138],
    [74, 135],
    [70, 132],
    [65, 130],
    [61, 127],
    [56, 124],
    [52, 121],
    [47, 119],
    [43, 116],
    [38, 113],
    [35, 110],
    [31, 107],
    [28, 103],
    [25, 100],
    [23, 97],
    [22, 94],
    [20, 90],
    [20, 87],
    [20, 84],
    [21, 80],
    [22, 77],
    [24, 74],
    [27, 71],
    [29, 69],
    [33, 66],
    [37, 64],
    [41, 62],
    [45, 61],
    [49, 59],
    [54, 59],
    [58, 58],
    [63, 58],
    [68, 59],
    [72, 59],
    [76, 60],
    [80, 62],
    [83, 63],
    [87, 65],
    [89, 67],
    [92, 69],
    [94, 71],
    [96, 73],
    [97, 75],
    [98, 77],
    [99, 79],
    [100, 80],
    [100, 81],
    [100, 82],
    [100, 82]
  ],
  pentagon: [
    [100, 50],
    [135, 85],
    [115, 135],
    [85, 135],
    [65, 85],
    [100, 50]
  ],
  kite: [
    [100, 40],
    [140, 70],
    [100, 160],
    [60, 70],
    [100, 40]
  ],
  crescent: [
    [120, 100],
    [119.85, 105.22],
    [119.4, 110.42],
    [118.66, 115.59],
    [117.63, 120.71],
    [116.31, 125.77],
    [114.71, 130.75],
    [112.84, 135.63],
    [110.71, 140.39],
    [108.33, 145.03],
    [105.71, 149.51],
    [102.85, 153.83],
    [99.77, 157.97],
    [96.48, 161.91],
    [92.99, 165.63],
    [89.32, 169.11],
    [85.47, 172.33],
    [81.47, 175.29],
    [77.32, 177.95],
    [73.03, 180.32],
    [68.62, 182.36],
    [64.1, 184.08],
    [59.48, 185.46],
    [54.77, 186.49],
    [50, 187.16],
    [45.17, 187.48],
    [40.3, 187.43],
    [35.41, 187.02],
    [30.51, 186.24],
    [25.6, 185.1],
    [20.71, 183.58],
    [15.85, 181.7],
    [11.03, 179.46],
    [6.27, 176.86],
    [1.57, 173.91],
    [97.43, 100],
    [97.57, 95.23],
    [96.43, 90.53],
    [95.01, 85.93],
    [93.29, 81.41],
    [91.3, 76.98],
    [89.03, 72.66],
    [86.48, 68.44],
    [83.66, 64.33],
    [80.57, 60.36],
    [77.23, 56.51],
    [73.62, 52.8],
    [69.78, 49.24],
    [65.68, 45.82],
    [61.36, 42.57],
    [56.83, 39.48],
    [52.08, 36.57],
    [47.14, 33.84],
    [42, 31.29],
    [36.68, 28.94],
    [31.19, 26.79],
    [25.56, 24.84],
    [19.77, 23.1],
    [13.86, 21.58],
    [7.83, 20.27],
    [1.62, 19.18],
    [1.62, 80.82],
    [7.83, 79.73],
    [13.86, 78.42],
    [19.77, 77.22],
    [25.56, 76.16],
    [31.19, 75.21],
    [36.68, 74.39],
    [42, 73.7],
    [47.14, 73.14],
    [52.08, 72.72],
    [56.83, 72.44],
    [61.36, 72.3],
    [65.68, 72.3],
    [69.78, 72.46],
    [73.62, 72.76],
    [77.23, 73.22],
    [80.57, 73.83],
    [83.66, 74.59],
    [86.48, 75.5],
    [89.03, 76.56],
    [91.3, 77.77],
    [93.29, 79.12],
    [95.01, 80.61],
    [96.43, 82.22]
  ],
  triquetra: [
    [100, 60],
    [85, 100],
    [100, 140],
    [115, 100],
    [100, 60],
    [80, 80],
    [120, 80],
    [100, 60],
    [80, 120],
    [120, 120],
    [100, 140]
  ],
  infinity: [
    [70, 100],
    [50, 80],
    [70, 60],
    [100, 70],
    [130, 60],
    [150, 80],
    [130, 100],
    [100, 90],
    [70, 100],
    [50, 120],
    [70, 140],
    [100, 130],
    [130, 140],
    [150, 120],
    [130, 100]
  ],
  chalise: [
    [85, 50],
    [115, 50],
    [100, 100],
    [80, 140],
    [120, 140],
    [100, 160],
    [100, 140]
  ],
  ankh: [
    [100, 50],
    [90, 70],
    [100, 90],
    [110, 70],
    [100, 50],
    [100, 90],
    [100, 150],
    [90, 170],
    [110, 170],
    [100, 150]
  ],
  hexagram: [
    [100, 50],
    [115, 80],
    [85, 80],
    [100, 50],
    [100, 150],
    [85, 120],
    [115, 120],
    [100, 150],
    [70, 100],
    [130, 100],
    [70, 100],
    [85, 120],
    [130, 100],
    [115, 120],
    [85, 80],
    [115, 80]
  ],
  droplet: [
    [100, 50],
    [120, 80],
    [140, 120],
    [100, 160],
    [60, 120],
    [80, 80],
    [100, 50]
  ],
  pique: [
    [100, 50],
    [80, 90],
    [70, 110],
    [100, 140],
    [130, 110],
    [120, 90],
    [100, 50],
    [90, 140],
    [110, 140],
    [100, 170],
    [90, 160],
    [110, 160],
    [100, 170]
  ],
  trefle: [
    [0, 0],
    [100, 100]
  ],
  keyhole: [
    [0, 0],
    [100, 100]
  ],
  "carolingian-cross": [
    [0, 0],
    [100, 100]
  ]
};

export default strokes;
